import { Link } from 'react-router-dom';

interface FooterLink {
  title: string;
  href: string;
}

interface SEOFooterProps {
  links: {
    holidays: FooterLink[];
    genres: FooterLink[];
    props: FooterLink[];
    combinations: FooterLink[];
  };
}

export function SEOFooter({ links }: SEOFooterProps) {
  return (
    <footer className="mt-16 border-t bg-muted/30 py-12">
      <div className="container grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <h2 className="mb-4 text-lg font-semibold">Holiday Sequences</h2>
          <ul className="space-y-2">
            {links.holidays.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-sm text-muted-foreground hover:text-primary hover:underline"
                >
                  {link.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        
        <div>
          <h2 className="mb-4 text-lg font-semibold">Genres</h2>
          <ul className="space-y-2">
            {links.genres.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-sm text-muted-foreground hover:text-primary hover:underline"
                >
                  {link.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        
        <div>
          <h2 className="mb-4 text-lg font-semibold">Props & Equipment</h2>
          <ul className="space-y-2">
            {links.props.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-sm text-muted-foreground hover:text-primary hover:underline"
                >
                  {link.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        
        <div>
          <h2 className="mb-4 text-lg font-semibold">Popular Combinations</h2>
          <ul className="space-y-2">
            {links.combinations.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-sm text-muted-foreground hover:text-primary hover:underline"
                >
                  {link.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
} 
